import * as React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";


export default function SliderVol({handleChooseBalanceClick}) {

    const [value, setValue] = React.useState(0);


    const handleSliderChange = (event,newValue) => {
        console.log(newValue)
        setValue(newValue);
        handleChooseBalanceClick(event,newValue)
      };

    const marks = [
        {
          value: 0,
          label: "%0"
        },
        {
          value: 25,
          label: "%25"
        },
        {
          value: 50,
          label: "%50"
        },
      
        {
          value: 75,
          label: "%75"
        },
        {
          value: 100,
          label: "%100"
        }
      ];
      
      function valuetext(value) {
        return `%${value}`;
      }
      
      function valueLabelFormat(value) {
        return `%${value} موجودی`;
      }
      


  return (
    <Box sx={{ width: '100%' }}>
      <Slider
        aria-label="Restricted values"
        defaultValue={0}
        valueLabelFormat={valueLabelFormat}
        getAriaValueText={valuetext}
        step={null}
        valueLabelDisplay="auto"
        marks={marks}
        onChange={handleSliderChange}

      />
    </Box>
  );
}
